import styled from "styled-components";
import designSystemColors from "../../styles";

export const Container = styled.div`
  width: 100%;
  background-color: ${designSystemColors.textGeneralButtons};
  display: flex;
  flex-wrap: wrap;
  padding: 16px;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
`;

export const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const PageTitle = styled.h1`
  font-size: 24px;
  color: ${designSystemColors.textDark};
  font-weight: bold;
  line-height: 20px;
`;

export const Selection = styled.div`
  height: 3px;
  width: 10%;
  background-color: ${designSystemColors.iconBlue};
  border-radius: 50px;
`;

export const Content = styled.div`
  width: 100%;
  margin-top: 3rem;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  padding: 0px 8px;
`;
